import { useQuery } from "@tanstack/react-query";
import { client } from "@johnpaul/jp-api-client";

import { APIBlock, JPClientRequest } from "@companion-core/shared/app/Interfaces/API";
import { sortData } from "@companion-core/shared/app/Utils/componentHelper";
import { getClientToken } from "@companion-core/shared/app/Utils/apiClient";

export const useBlocks = (pageSlug: string, lang: string) => {
  return useQuery({
    queryKey: ["blocks", pageSlug, lang],
    queryFn: async () => {
      await getClientToken();
      return client.content.v2.pages.getPageBlocks(pageSlug, { lang: lang });
    },
    select: (data: JPClientRequest<APIBlock>) => {
      if (!data || !data.data || !data.data.results) {
        return [];
      }
      try {
        return sortData(data.data.results) as APIBlock[];
      } catch {
        return [];
      }
    },
    enabled: !!pageSlug,
    gcTime: 0,
    retry: false,
  });
};
